import {
  ApiDataSourceSpec,
  apiDataSource,
} from '@/io/datasource/ApiDatasource';
import {
  LocalStorageDataSourceSpec,
  localStorageDataSource,
} from '@/io/datasource/LocalStorageDatasource.ts';
import {
  SessionStorageDataSourceSpec,
  sessionStorageDataSource,
} from '@/io/datasource/SessionStorageDatasource.ts';
import {
  BGMPreferences,
  PatientListUISettings,
  bgmPreferencesSchema,
  patientListUISettingsSchema,
} from '@/models/UISettingsModel.ts';
import { ExtendedUser, extendedUserSchema } from '@/models/UserModel';
import { cz } from '@/utils/zodUtils.ts';

export class UserRepository {
  constructor(
    private readonly datasource: ApiDataSourceSpec = apiDataSource,
    private readonly localDatasource: LocalStorageDataSourceSpec = localStorageDataSource,
    private readonly sessionDatasource: SessionStorageDataSourceSpec = sessionStorageDataSource,
  ) {}

  getUser = (): Promise<ExtendedUser> => {
    return this.datasource.get('practitioner/me/', extendedUserSchema);
  };

  getFeatureFlags = (): Promise<Record<string, boolean>> => {
    return this.datasource.get(
      '/feature-flags/',
      cz.unsafe<Record<string, boolean>>(),
    );
  };

  getBGMPreferences = async (userId: string): Promise<BGMPreferences> => {
    const result = await this.localDatasource.retrieve(
      userId,
      'BGMPreferences',
      bgmPreferencesSchema,
    );
    return result ?? {};
  };

  updateBGMPreferences = async (userId: string, data: BGMPreferences) => {
    await this.localDatasource.store(userId, 'BGMPreferences', data);
  };

  getPatientListUISettings = async (
    userId: string,
  ): Promise<PatientListUISettings> => {
    const result = await this.sessionDatasource.retrieve(
      userId,
      'patientList',
      patientListUISettingsSchema,
    );
    return result ?? {};
  };

  updatePatientListUISettings = async (
    userId: string,
    data: PatientListUISettings,
  ) => {
    await this.sessionDatasource.store(userId, 'patientList', data);
  };
}
